import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const OperadorParametroFaixaBancariaClusterService = 
{
    deletarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'parametros-faixa-bancaria-cluster/excel/deletar', 'excelFaixaBancariaClusterDeletar');
    },
    salvarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'parametros-faixa-bancaria-cluster/excel', 'excelFaixaBancariaCluster');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> 
    {
        return Client.getBlob('parametros-faixa-bancaria-cluster/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> 
    {
        return Client.post('parametros-faixa-bancaria-cluster/eventGrid', {});
    }
}

export default OperadorParametroFaixaBancariaClusterService;